exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "a[data-v-04e1da01]{color:inherit;text-decoration:none;cursor:pointer!important;pointer-events:all;-webkit-user-select:none;user-select:none;-webkit-touch-callout:none}p[data-v-04e1da01]{margin-bottom:12px}ol[data-v-04e1da01]{list-style:inside}.header[data-v-04e1da01]{position:fixed;top:0;height:70px;width:100%;z-index:3;background-color:#000;pointer-events:all;color:#ded7c8;border-color:#ded7c8;z-index:301}.header-container[data-v-04e1da01]{position:relative;max-width:1600px;margin:0 auto}.header-logo[data-v-04e1da01]{position:absolute;margin:20px;width:120px;z-index:1;cursor:pointer}.header-getStarted[data-v-04e1da01]{position:absolute;top:10px;right:100px;height:100%;margin:10px auto}@media (max-width:440px){.header-getStarted[data-v-04e1da01]{right:80px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader?minimize!../node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-04e1da01","scoped":true,"hasInlineConfig":false}!../node_modules/sass-loader/lib/loader.js?indentedSyntax!../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./fixed/Header.vue
// module id = 559
// module chunks = 0